const normalizeWebsiteLink = website =>
	website.startsWith('@')
		? `https://instagram.com/${website.replace(/^@/, '')}`
		: /^https?:\/\//i.test(website)
			? website
			: `https://${website}`;

export default normalizeWebsiteLink;
